import { Observable } from 'rxjs';

export interface ApplicationInfo {
    name?: string;
    version?: string;
    buildTimestamp?: string;
    environment?: string;
    notificationDeliveryMode?: string;
    notificationRedirectAddresses?: string[];
    simulatedDate?: string;
}

export abstract class AppVersionService {
    public abstract config(): Promise<null>;
    public abstract fetchUiVersion(): Promise<string>;
    public abstract get uiVersion();
    public abstract get serverVersion();
    public abstract get serverInfo(): ApplicationInfo;
    public abstract get effectiveNow(): Date;
    public abstract get simulatedDateTime(): Date | null;
    public abstract get clockChanged$(): Observable<void>;
    public abstract notifyClockChanged(): void;
    public abstract get reviewDatesChanged$(): Observable<void>;
    public abstract notifyReviewDatesChanged(): void;
}
